export default __webpack_public_path__ + "static/rsz_arquivei-b40968c57d925f68f110d2d01e21c42e.png";